import { SnackbarContext } from "App";
import axios from "axios";
import { PinnedLogsContext } from "components/AllLogHistoryNew";
import config from "config/config";
import useCommunication from "hooks/context-hooks/useCommunication";
import useUserContext from "hooks/context-hooks/useUserContext";
import { useContext } from "react";
import { useMutation } from "react-query";
import { POST } from "utils/restUtils";

export const useAddPatientNote = (onCompleted: () => void) => {
  const { token } = useUserContext();
  const pinnedLogContext = useContext(PinnedLogsContext);
  const { setSnack } = useContext(SnackbarContext);
  const { refetch } = useCommunication();
  return useMutation(
    async (noteData: any) => {
      const response = await POST(
        `${config.BASE_URL}/api/v1/notes?api_token=${token}`,
        { ...noteData },
        { api_token: token }
      );
      return response.data;
    },
    {
      onSuccess: (e) => {
        pinnedLogContext.refetchLogHistory();
        setSnack({
          open: true,
          severity: "success",
          message: "Note added",
        });
        refetch();
        onCompleted && onCompleted();
      },
    }
  );
};
